var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.72V3.33c0-.35-.28-.62-.62-.62s-.62.28-.62.62v2.39c-.96.27-1.67 1.15-1.67 2.19s.71 1.92 1.67 2.19v6.56c0 .35.28.62.62.62s.62-.28.62-.62V10.1c.96-.27 1.67-1.15 1.67-2.19S8.46 5.99 7.5 5.72Zm-.62 3.24c-.57 0-1.04-.47-1.04-1.04s.47-1.04 1.04-1.04 1.04.47 1.04 1.04-.47 1.04-1.04 1.04Zm8.54 3.12c0-1.05-.71-1.92-1.67-2.19V3.33c0-.35-.28-.62-.62-.62s-.62.28-.62.62v6.56c-.96.27-1.67 1.15-1.67 2.19s.71 1.92 1.67 2.19v2.39c0 .35.28.62.62.62s.62-.28.62-.62v-2.39c.96-.27 1.67-1.15 1.67-2.19Zm-2.29 1.04c-.57 0-1.04-.47-1.04-1.04s.47-1.04 1.04-1.04 1.04.47 1.04 1.04-.47 1.04-1.04 1.04Z",
    fill: "current"
  })));
};
export default SvgFilter;